import { CircularProgress } from "@mui/material";
import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function FeedSkeletonLoader() {
  return (
    <div className="d-flex flex-column min-vh-100 gap-4 p-3 align-items-center">
      {[...Array(3)].map((_, index) => (
        <div
          key={index}
          style={{
            width: "90%",
            maxWidth: "100%",
          }}
        >
          <Skeleton
            baseColor="#ddd"
            highlightColor="#f5deb3"
            width="100%"
            height="6vh"
          />
          <Skeleton
            baseColor="#ddd"
            highlightColor="#f5deb3"
            width="100%"
            height="3vh"
            style={{ marginTop: "1vh" }}
          />
          <Skeleton
            baseColor="#ddd"
            highlightColor="#f5deb3"
            width="100%"
            height="50vh"
            style={{ marginTop: "2vh" }}
          />
        </div>
      ))}
    </div>
  );
}
